import React, { ReactElement } from 'react'
import {
  Dropdown,
  Stack,
  Box,
  ResetButton,
  Flex,
  Icon,
  Text,
} from '@mindfulchefuk/design-system'
import mealPlanConfig, { TMealPlan } from '@mindfulchefuk/config/mealPlanConfig'
import { RadioButton } from '@mindfulchefuk/design-system/Forms/RadioButton/RadioButton'
import titleCase from '@mindfulchefuk/utils/titleCase'
import { TOnboardingRecipeFilterHandlers } from '../OnboardingRecipeFilterHandlers.types'

type TOnboardingMealPlanFilter = {
  onChange?: TOnboardingRecipeFilterHandlers['mealPlan']
  onToggle: () => void
  isOpen: boolean
  mealPlan: string
}

export const OnboardingChooseRecipesMealPlanFilter = ({
  mealPlan,
  onChange,
  onToggle,
  isOpen,
}: TOnboardingMealPlanFilter): ReactElement => (
  <Box position="relative" id="meal-plan-filter">
    <ResetButton
      display="block"
      data-testid="recipe-filter-meal-plan"
      onClick={() => onToggle()}
    >
      <Flex color="aubergine">
        <Icon type="knife-and-fork" flexShrink={0} mr={8} />
        <Text
          variant="body-sm-500-caps"
          as="span"
          color="aubergine"
          data-testid="meal-plan-label"
        >
          {mealPlanConfig.find((plan) => plan.value === mealPlan).title}
        </Text>
        <Icon ml={10} type={isOpen ? 'chevron-up' : 'chevron-down'} />
      </Flex>
    </ResetButton>
    <Dropdown
      alignment="left"
      data-test-id="recipe-dropdown-meal-plan"
      isOpen={isOpen}
      onToggle={onToggle}
      width={240}
    >
      <Stack spacing={10}>
        {mealPlanConfig.map(({ value, label }) => {
          const id = `meal-plan-${value}`
          return (
            <RadioButton
              id={id}
              data-testid={`${id}-radio`}
              key={id}
              value={value}
              onChange={(event) => onChange(event.target.value as TMealPlan)}
              checked={value === titleCase(mealPlan, true)}
            >
              {label}
            </RadioButton>
          )
        })}
      </Stack>
    </Dropdown>
  </Box>
)
